var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.noHeader != true)?_c('self-header'):_vm._e(),_c('div',{staticClass:"app-content"},[_c('router-view')],1),(_vm.$route.meta.noFooter != true)?_c('self-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }